import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=1a31b3cd&scoped=true&lang=pug&"
import script from "./columns.vue?vue&type=script&setup=true&lang=js&"
export * from "./columns.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./columns.vue?vue&type=style&index=0&id=1a31b3cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31b3cd",
  null
  
)

export default component.exports